
import React from 'react';
import styled from "styled-components";
import { Container } from "react-bootstrap";
import BannerClaim from '../../../assets/images/claims/Imagen banner  1080 x 786.png'
export const Title = styled.h1`
  display: block;
  color: #1d252d;
  font-family: SantanderHeadlineW05-Bold;
  padding: 60px 16;
  margin-top: 120px;
  margin-left: 16px;
  width: 250px;
  @media (min-width: 1024px) {
    height: 440px;
    width: 100%;
    font-weight: 700;
    font-size: 52px;
    line-height: 64px;
    margin-left: 36px;
  }
`;

const BannerComplaintsBook: React.FC = () => {


  return (
    <div style={{  paddingBottom: 48 }}>
           <div className="boxi-claim" >
        <Container>
          <div className="banner-container-banner" >
            <div className="banner-container-text">
              <span className="banner-text-banner"> ¿Cómo podemos <span style={{color:"#EC0000"}}>ayudarte?</span><br />
                <span className="banner-subText-banner">Cuéntanos qué necesitas y trabajemos juntos para resolverlo.</span>
              </span>
            </div>
            <div>
              <img className="banner-image" src={BannerClaim} alt="Banner Donde Estamos" />
            </div>
          </div>
        </Container>

      </div>
    </div>
  );
}

export default BannerComplaintsBook;